import React from 'react';
import Footer from './footer'
import Header from './header'
import CssBaseline from '@material-ui/core/CssBaseline';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { Helmet } from "react-helmet";
import '@babel/polyfill';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#ffffff',
      main: '#fafafa',
      dark: '#c7c7c7',
      contrastText: '#000000',
    },
    secondary: {
      light: '#6d6d6d',
      main: '#424242',
      dark: '#1b1b1b',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function storeLayout(Component) {
  function storeLayout(props) {
    return (
      <MuiThemeProvider theme={theme}>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Codes and Standards Training</title>
          <link rel="canonical" href="https://www.casti.ca" />
        </Helmet>
        <CssBaseline />
        <Header {...props} />
        <Component {...props} />
        <Footer {...props} />
      </MuiThemeProvider>
    )
  }
  return storeLayout;
}

export default storeLayout;
